<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 년도 -->
          <c-datepicker
            type="year"
            default="today"
            label="LBLYEAR"
            name="planYear"
            v-model="searchParam.planYear"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 진행단계 -->
          <c-select
            type="search"
            stepperGrpCd="SAI_INTERNAL_YEAR_PLAN_STEP_CD"
            itemText="stepperMstNm"
            itemValue="stepperMstCd"
            name="saiInternalYearPlanStepCd"
            label="LBLSTEPPROGRESS"
            v-model="searchParam.saiInternalYearPlanStepCd"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <!--연간 안전보건 내부심사 실시계획서 목록-->
    <c-table
      ref="table"
      title="LBL0010113"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <!--등록-->
          <c-btn v-if="editable" label="LBLREG" icon="add" @btnClicked="openPop" />
          <!--검색-->
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'internal-year-plan',
  data() {
    return {
      searchParam: {
        plantCd: null,
        planYear: '',
        saiInternalYearPlanStepCd: null,
      },
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            //사업장
            label: 'LBLPLANT',
            align: 'center',
            style: 'width:120px',
            sortable: true,
          },
          {
            name: 'planYear',
            field: 'planYear',
            //년도
            label: 'LBLYEAR',
            align: 'center',
            style: 'width:120px',
            sortable: true,
          },
          {
            name: 'planName',
            field: 'planName',
            //실시계획서명
            label: 'LBL0010105',
            align: 'left',
            style: 'width:300px',
            sortable: true,
            type: 'link'
          },
          {
            name: 'deptName',
            field: 'deptName',
            //주관부서
            label: 'LBL0010106',
            align: 'center',
            style: 'width:110px',
            sortable: true,
          },
          {
            name: 'saiInternalYearPlanStepName',
            field: 'saiInternalYearPlanStepName',
            //진행상태
            label: 'LBLPROGRESS',
            align: 'center',
            style: 'width:90px',
            sortable: true,
          },
          {
            // 결재진행단계
            name: 'approvalStatusName',
            field: 'approvalStatusName',
            label: 'LBL0000212',
            align: 'center',
            sortable: true,
            style: 'width:100px',
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sai.internal.yearPlan.list.url;
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.openPop(row);
    },
    openPop(row) {
      this.popupOptions.title = 'LBL0010107';   //연간 안전보건 내부심사 실시계획서 상세
      this.popupOptions.param = {
        saiInternalYearPlanId: row ? row.saiInternalYearPlanId : '',
      };
      this.popupOptions.target = () => import(`${'./internalYearPlanDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
